angular
  .module("searchTableDigital.components", [])
  .component("searchTableDigital", {
    templateUrl: "ng/components/searchTableDigital/searchTableDigital.view.html",
    controllerAs: "searchDigitalCtrl",
    bindings: {
      onPressSearch: "&",
      portal: "=",
      mode: "<",
      restIsFinished: "<",
      listProduct: "<",
      contractNumbers: "<",
      practiceStatus: "<",
      irapYearList: "<",
      isIrap: "<",
      isAra: "<",
      loaderRestCalling: '<'
    },
    controller: function (
      $typeDomainService,
      $arcService,
      $uniService,
      $scope,
      $searchUserService,
      $financialApiService,
      $storageService,
      $simulationService,
      $rootScope
    ) {
      var self = this;
      self.stateSelected = "";

      self.$onInit = function () {
        self.permissions = JSON.parse(window.sessionStorage.getItem('alba-appConfig'))
        self.functionality = $storageService.getAppConfig().allFunctionalities;
        self.functIsPresent = false;
        var listOfElement = ["PREVENTIVO_LEVEL2", "PREVENTIVO_LEVEL3", "VIEW_ALL_HOME"];
        listOfElement.forEach(function (funct) {
          self.functIsPresent = self.functIsPresent ||
            !!self.functionality.find(function (iesimo) {
              return iesimo == funct
            })
        })

        self.listaCategorie = [];
        self.listaTipoRichiesta = [];
        self.categoriaSelezionata = undefined;
        self.tipoRichiestaSelezionata = undefined;
        self.listaProdotti = [];
        self.prodottoSelezionato = undefined;
        self.listaFaseGestionale = [];
        self.faseGestionaleSelezionato = "";
        self.listaCdRaggrConvenzione = [];
        self.cdRaggrConvenzioneSelezionato = "";
        self.listaClientManager = [];
        self.clientManagerSelezionato = "";
        self.listaAbi = [];
        self.abiSelezionato = "";
        self.listaCab = [];
        self.cabSelezionato = "";
        self.listaStatoIterDelibera = [];
        self.statoIterDeliberaSelezionato = "";
        self.listaPoloRiferimento = [];
        self.poloRiferimentoSelezionato = "";

        switch (self.mode) {
          case 'CTR':
            self.populateContracts()
          case 'IRA':
            self.supportModel = {
              years: undefined,
              dataAvvioDa: undefined,
              dataAvvioA: undefined,
              dataFineDa: undefined,
              dataFineA: undefined,
              contratto: null,
              stato: null,
              prodotto: null,
              vediPratiche: false,
              modulo: undefined
            }

            self.dataAvvioDaValid = true;
            self.dataAvvioAValid = true;
            self.dataFineDaValid = true;
            self.dataFineAValid = true;

            self.numeriContratti = [];
            self.firstTime = true;
            break;
          case 'DOC':
            var date = new Date()
            self.supportModel = {
              docCategory: null,
              docType: null,
              contractServicePojo: {
                modulo: undefined,
                idContract: undefined
              },
              emissionDateTo: moment(date).format('DD/MM/YYYY'),
              emissionDateFrom: moment(date, 'DD/MM/YYYY').subtract(6, 'months').format('DD/MM/YYYY'),
              endDateFrom: undefined,
              endDateTo: undefined,
              annoRiferimento: null,
              vediPratiche: false,
              numeroContratto: undefined,
              numeroModulo: undefined,
              daLeggere: false
            }
            self.numeriContratti = [{}];
            self.docCategories = [{}];
            self.docTypes = [{}];
            self.emDtStartValid = true;
            self.emDtEndValid = true;
            self.dueDtStartValid = true;
            self.dueDtEndValid = true;
            getDropDowns();
            self.populateContracts()
            break;
          default:
            self.supportModel = {
              years: null,
              id: null,
              dataInizio: undefined,
              dataFine: undefined,
              preventivo: null,
              anno: null,
              contratto: null,
              ragSocCliente: null,
              pIvaCliente: null,
              ndgVendorUser: null,
              ndgVendorSelected: null,
              ndgSegnalatore: null,
              ndgCliente: null,
              categoria: undefined,
              tipoRichiesta: undefined,
              vediPratiche: true,
              vediPraticheMyArea: false
            }
            self.dataInizioValid = true;
            self.dataFineValid = true;
            self.statoPratiche = [];


        }
        if (self.permissions.allFunctionalities) {
          self.permissions.allFunctionalities.forEach(function (item) {
            if (item === 'RICERCA_EVOLUTA_HOME_PLUS' || item === 'ACQ_CONTRATTI') {



            }
            self.hideFaseGestionaleCtr = true;
            if (item === 'RICERCA_EVOLUTA_HOME') {

            }

            if (item === 'PREVENTIVO_LEVEL2' || item === 'PREVENTIVO_LEVEL3' || item === 'RICERCA_EVOLUTA_HOME_PLUS') {
              self.getAllStatoIterDelibera();
            }
          })
        }
        self.defaultYear = undefined;
        self.activateButton = false;
        self.supportModel.vediPratiche = self.functionality.includes("VIEW_ALL_HOME");
      }
      self.$onChanges = function (changes) {
        if (changes.restIsFinished && changes.restIsFinished.currentValue) {

        }
        if (changes.listProduct && changes.listProduct.currentValue) {
          self.prodotti = changes.listProduct.currentValue;
        }
        if (self.isIrap && changes.practiceStatus && changes.practiceStatus.currentValue) {
          self.stati = changes.practiceStatus.currentValue;
        }
        if (self.isIrap && changes.irapYearList && changes.irapYearList.currentValue) {
          self.annoRiferimentoIrap = changes.irapYearList.currentValue;
          var selectedYear = self.annoRiferimentoIrap.find(function (element) {
            return element.selected == true;
          })
          if (self.supportModel) {
            self.supportModel.years = selectedYear;
          }

        }

        if (changes.loaderRestCalling && typeof changes.loaderRestCalling.currentValue != "undefined") {
          self.loaderRestCalled = changes.loaderRestCalling.currentValue;
        }
      }
      $scope.$on("contractsReady", function () {
        if (self.firstTime) {
          if ($scope.$parent.modelToGetDropdowns && $scope.$parent.modelToGetDropdowns.listContratti.length > 0) {
            $scope.$parent.modelToGetDropdowns.listContratti.forEach(function (item) {
              self.numeriContratti.push(item.numeroContratto);
            });

            self.numeriContratti = removeDuplicates($scope.$parent.modelToGetDropdowns.listContratti, 'numeroContratto');
            self.stati = removeDuplicates($scope.$parent.modelToGetDropdowns.listContratti, 'codFaseGestionale');
            self.prodotti = removeDuplicates($scope.$parent.modelToGetDropdowns.listContratti, 'codProdotto');
          }
          self.firstTime = false;
        }
      });

      var getDropDowns = function () {
        switch (self.mode) {
          case 'CTR':
          case 'IRA':
            break;
          case 'DOC':
            self.initInput = {
              functionId: 'ARCHIVIO_DOC'
            }

            self.secondInput = {
              functionId: "ARCHIVIO_DOC",
              level: 1,
              previousSelections: []
            }

            $uniService
              .getDropDown(self.initInput)
              .then(function (response) {
                if (response) {
                  self.supportModel.docCategory = response[0];
                  self.docCategories = response;
                  self.enableDateFilters = true;
                  self.secondInput.previousSelections.push({
                    functionId: 'ARCHIVIO_DOC',
                    level: 0,
                    value: self.supportModel.docCategory.value
                  });

                  $uniService
                    .getDropDown(self.secondInput)
                    .then(function (response) {
                      self.supportModel.docType = response[0];
                      self.docTypes = response;

                      self.filter = {
                        limit: 10,
                        offset: 0,
                        pageIndex: 1,
                        totalPages: 0,
                        orderColumnName: "UPDATE_DATE",
                        orderType: "DESC",
                        contractServicePojo: self.supportModel.contractServicePojo,
                        docCategory: self.supportModel.docCategory ? self.supportModel.docCategory.value : undefined,
                        docType: self.supportModel.docType ? self.supportModel.docType.value : undefined,
                        refYear: self.supportModel.annoRiferimento ? self.supportModel.annoRiferimento : undefined,
                        emissionDateFrom: self.emDtStartValid ? self.supportModel.emissionDateFrom : undefined,
                        emissionDateTo: self.emDtEndValid ? self.supportModel.emissionDateTo : undefined,
                        endDateFrom: self.dueDtStartValid ? self.supportModel.endDateFrom : undefined,
                        endDateTo: self.dueDtEndValid ? self.supportModel.endDateTo : undefined,
                        showAll: self.supportModel.vediPratiche
                      }

                      if (self.supportModel.daLeggere) {
                        self.supportModel = {
                          daLeggere: true
                        }
                        self.filter.daLeggere = true;
                      }

                      self.onPressSearch({
                        filter: self.filter
                      })
                    })
                    .catch(function (error) {
                      console.log("ERROR:", error);
                    })
                }

              })
              .catch(function (error) {
                console.log("ERROR: ", error)
              })

            break;
          default:
            return;
        }
      };

      var removeDuplicates = function (originalArray, objKey) {
        var trimmedArray = [];
        var values = [];
        var value;

        for (var i = 0; i < originalArray.length; i++) {
          value = originalArray[i][objKey];

          if (values.indexOf(value) === -1) {
            switch (objKey) {
              case 'codFaseGestionale':
                trimmedArray.push(originalArray[i]);
                break;
              case 'codProdotto':
                trimmedArray.push(originalArray[i]);
                break;
              case 'numeroAnno':
                trimmedArray.push(originalArray[i].numeroAnno);
                break;
              case 'numeroContratto':
                trimmedArray.push(originalArray[i].numeroContratto);
                break;
              default:
                return;
            }
            values.push(value);
          }
        }
        return trimmedArray;
      }

      var statoPratiche = function () {
        self.loaderaStatus = true;
        $typeDomainService
          .getStatusList()
          .then(function (response) {
            self.statoPratiche = response.domainList;
            self.loaderaStatus = false;
          })
      }

      self.getStartDate = function (value, mode) {
        if (!value) {
          return;
        }

        if (!mode) {
          return moment(value, "DD/MM/YYYY").add(1, "days").format("DD/MM/YYYY");
        } else {
          return moment(value, "DD/MM/YYYY").format("DD/MM/YYYY");
        }

      }

      self.handleChange = function (property, value) {
        var std = Object.keys(self.supportModel).some(function (property) {
          return self.supportModel[property];
        })

        switch (self.mode) {
          case 'CTR':
            if (property == 'contract') {
              self.supportModel.modulo = value.numeroModulo;
            }
          case 'IRA':
            if (self.supportModel.dataAvvioDa) {
              var dataAvvioDaComp = self.supportModel.dataAvvioDa.split('/').reverse().join("-");
              dataAvvioDaComp = moment(dataAvvioDaComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
            if (self.supportModel.dataAvvioA) {
              var dataAvvioAComp = self.supportModel.dataAvvioA.split('/').reverse().join("-");
              dataAvvioAComp = moment(dataAvvioAComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
            if (self.supportModel.dataFineDa) {
              var dataFineDaComp = self.supportModel.dataFineDa.split('/').reverse().join("-");
              dataFineDaComp = moment(dataFineDaComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
            if (self.supportModel.dataFineA) {
              var dataFineAComp = self.supportModel.dataFineA.split('/').reverse().join("-");
              dataFineAComp = moment(dataFineAComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }

            if (std) {
              if (self.supportModel.dataAvvioDa && !moment(self.supportModel.dataAvvioDa, 'DD/MM/YYYY', true).isValid()) {
                self.dataAvvioDaValid = false;
                return;
              }

              if (self.supportModel.dataAvvioA && !moment(self.supportModel.dataAvvioA, 'DD/MM/YYYY', true).isValid()) {
                self.dataAvvioAValid = false;
                return;
              }

              if (self.supportModel.dataFineDa && !moment(self.supportModel.dataFineDa, 'DD/MM/YYYY', true).isValid()) {
                self.dataFineDaValid = false;
                return;
              }

              if (self.supportModel.dataFineA && !moment(self.supportModel.dataFineA, 'DD/MM/YYYY', true).isValid()) {
                self.dataFineAValid = false;
                return;
              }

              if (moment(dataAvvioDaComp).isAfter(dataAvvioAComp)) {
                self.supportModel.dataAvvioA = null;
                self.rangeNotValid = true;
              } else {
                self.rangeNotValid = false;
              }

              if (moment(dataFineDaComp).isAfter(dataFineAComp)) {
                self.supportModel.dataFineA = null;
                self.rangeNotValid = true;
              } else {
                self.rangeNotValid = false;
              }

              self.dataAvvioAValid = true;
              self.dataAvvioDaValid = true;
              self.dataFineAValid = true;
              self.dataFineDaValid = true;

            }

            if (self.isAra) {
              if (self.supportModel.contratto && self.supportModel.years && self.supportModel.modulo) {
                self.activateButton = true;
              } else if (self.supportModel.contratto == "" || self.supportModel.years == "" || self.supportModel.modulo == "") {
                self.activateButton = false;
              }
            }
            break;
          case 'DOC':
            if (property === "emissionDateFrom") {
              self.supportModel.emissionDateFrom = value;
            }

            if (property === "emissionDateTo") {
              self.supportModel.emissionDateTo = value;
            }

            if (property === "endDateFrom") {
              self.supportModel.endDateFrom = value;
            }

            if (property === "endDateTo") {
              self.supportModel.endDateTo = value;
            }

            if (property === "contract") {
              self.supportModel.numeroContratto = value && value.numeroContratto ? value.numeroContratto : null;
              self.supportModel.numeroModulo = value && value.numeroModulo ? value.numeroModulo : null;
            }

            if (self.supportModel.emissionDateFrom) {
              var emissionDateFromComp = self.supportModel.emissionDateFrom.split('/').reverse().join("-");
              emissionDateFromComp = moment(emissionDateFromComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
            if (self.supportModel.emissionDateTo) {
              var emissionDateToComp = self.supportModel.emissionDateTo.split('/').reverse().join("-");
              emissionDateToComp = moment(emissionDateToComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
            if (self.supportModel.endDateFrom) {
              var endDateFromComp = self.supportModel.endDateFrom.split('/').reverse().join("-");
              endDateFromComp = moment(endDateFromComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
            if (self.supportModel.endDateTo) {
              var endDateToComp = self.supportModel.endDateTo.split('/').reverse().join("-");
              endDateToComp = moment(endDateToComp, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }

            if (self.supportModel.emissionDateFrom && !moment(self.supportModel.emissionDateFrom, 'DD/MM/YYYY', true).isValid()) {
              self.emDtStartValid = false;
              if (self.supportModel.docCategory && self.supportModel.docCategory.value == 'fiscale') {
                self.disableSearchButton = true;
                return;
              }
            } else {
              if (self.supportModel.emissionDateFrom) {
                self.supportModel.emissionDateFrom = moment(self.supportModel.emissionDateFrom, 'DD/MM/YYYY').format('DD/MM/YYYY');
              }
              self.emDtStartValid = true;
            }

            if (self.supportModel.emissionDateTo && !moment(self.supportModel.emissionDateTo, 'DD/MM/YYYY', true).isValid()) {
              self.emDtEndValid = false;
              if (self.supportModel.docCategory && self.supportModel.docCategory.value == 'fiscale') {
                self.disableSearchButton = true;
                return;
              }
            } else {
              if (self.supportModel.emissionDateTo) {
                self.supportModel.emissionDateTo = moment(self.supportModel.emissionDateTo, 'DD/MM/YYYY').format('DD/MM/YYYY');
              }
              self.emDtEndValid = true;
            }

            if (self.supportModel.endDateFrom && !moment(self.supportModel.endDateFrom, 'DD/MM/YYYY', true).isValid()) {
              self.dueDtStartValid = false;
              if (self.supportModel.docCategory && self.supportModel.docCategory.value == 'fiscale') {
                self.disableSearchButton = true;
                return;
              } else {
                self.disableSearchButton = false;
              }
            } else {
              if (self.supportModel.endDateFrom) {
                self.supportModel.endDateFrom = moment(self.supportModel.endDateFrom, 'DD/MM/YYYY').format('DD/MM/YYYY');
              }
              self.dueDtStartValid = true;
            }

            if (self.supportModel.endDateTo && !moment(self.supportModel.endDateTo, 'DD/MM/YYYY', true).isValid()) {
              self.dueDtEndValid = false;
              if (self.supportModel.docCategory && self.supportModel.docCategory.value == 'fiscale') {
                self.disableSearchButton = true;
                return;
              }
            } else {
              if (self.supportModel.endDateTo) {
                self.supportModel.endDateTo = moment(self.supportModel.endDateTo, 'DD/MM/YYYY').format('DD/MM/YYYY');
              }
              self.dueDtEndValid = true;
            }


            if (!self.supportModel.docCategory) {
              self.disableSearchButton = true;
              return;
            }
            if (self.supportModel.docCategory && self.supportModel.docCategory.value == "comunicGarante" && !self.supportModel.numeroContratto) {
              self.disableSearchButton = true;
              return;
            }

            if (moment(emissionDateFromComp).isAfter(emissionDateToComp)) {
              self.supportModel.emissionDateTo = null;
            }

            if (moment(endDateFromComp).isAfter(endDateToComp)) {
              self.supportModel.endDateTo = null;
            }


            self.disableSearchButton = false;
            //self.showMessageOne = false;
            //self.showMessageTwo = false;
            break;
          default:
            if (std) {
              if (self.supportModel.dataInizio && !moment(self.supportModel.dataInizio, 'DD/MM/YYYY', true).isValid()) {
                self.dataInizioValid = false;
                return;
              }

              if (self.supportModel.dataFine && !moment(self.supportModel.dataFine, 'DD/MM/YYYY', true).isValid()) {
                self.dataFineValid = false;
                return;
              }
              self.dataInizioValid = true;
              self.dataFineValid = true;
            }
        }

        switch (property) {
          case 'abi':
            self.listaCab = [];
            self.cabSelezionato = "";

            if (self.abiSelezionato) {
              self.getAllCab(value);
            }
            break;
          default:
            break
        }
      }

      self.check = function (el) {
        el.vediPratiche = !el.vediPratiche;
        if (el.vediPratiche) {
          self.supportModel.vediPraticheMyArea = false;
        }
      }

      self.checkMyArea = function (el) {
        el.vediPraticheMyArea = !el.vediPraticheMyArea;
        if (el.vediPraticheMyArea) {
          self.supportModel.vediPratiche = false;
        }
      }



      self.checkDaleggere = function (el) {
        el.daLeggere = !el.daLeggere;

        if (el.daLeggere) {
          self.supportModel = {};
          self.supportModel.daLeggere = true;
        }
      }

      self.search = function () {
        self.loaderRestCalled = true;
        switch (self.mode) {
          case 'CTR':
            self.filter = {
              limit: 10,
              offset: 0,
              pageIndex: 1,
              totalPages: 0,
              orderColumnName: "UPDATE_DATE",
              orderType: "DESC",
              status: self.supportModel.stato ? self.supportModel.stato.codFaseGestionale : undefined,
              contract: self.supportModel.contratto && self.supportModel.contratto.numeroContratto ? self.supportModel.contratto.numeroContratto : undefined,
              product: self.supportModel.prodotto ? self.supportModel.prodotto.codProdotto : undefined,
              dataAvvioDa: self.dataAvvioDaValid ? self.supportModel.dataAvvioDa : undefined,
              dataAvvioA: self.dataAvvioAValid ? self.supportModel.dataAvvioA : undefined,
              dataFineDa: self.dataFineDaValid ? self.supportModel.dataFineDa : undefined,
              dataFineA: self.dataFineAValid ? self.supportModel.dataFineA : undefined,
              showAll: self.supportModel.vediPratiche ? self.supportModel.vediPratiche : false,
              modulo: self.supportModel.modulo ? self.supportModel.modulo : undefined
            }
            break;
          case 'CAL':
            self.filter = {
              limit: 10,
              offset: 0,
              pageIndex: 1,
              totalPages: 0,
              orderColumnName: "UPDATE_DATE",
              orderType: "DESC",
              status: self.supportModel.stato ? self.supportModel.stato.codFaseGestionale : undefined,
              contract: self.supportModel.contratto,
              product: self.supportModel.prodotto ? self.supportModel.prodotto.codProdotto : undefined,
              dataAvvioDa: self.dataAvvioDaValid ? self.supportModel.dataAvvioDa : undefined,
              dataAvvioA: self.dataAvvioAValid ? self.supportModel.dataAvvioA : undefined,
              dataFineDa: self.dataFineDaValid ? self.supportModel.dataFineDa : undefined,
              dataFineA: self.dataFineAValid ? self.supportModel.dataFineA : undefined,
              showAll: self.supportModel.vediPratiche ? self.supportModel.vediPratiche : false
            }
            break;
          case 'IRA':
            self.filter = {
              annoRiferimentoIrap: self.supportModel.years ? self.supportModel.years : undefined,
              limit: 10,
              offset: 0,
              pageIndex: 1,
              totalPages: 0,
              orderColumnName: "UPDATE_DATE",
              orderType: "DESC",
              status: self.supportModel.stato && self.supportModel.stato.dscFaseGestionale,
              contract: self.supportModel.contratto,
              product: self.supportModel.prodotto ? self.supportModel.prodotto : undefined,
              dataAvvioDa: self.dataAvvioDaValid ? self.supportModel.dataAvvioDa : undefined,
              dataAvvioA: self.dataAvvioAValid ? self.supportModel.dataAvvioA : undefined,
              dataFineDa: self.dataFineDaValid ? self.supportModel.dataFineDa : undefined,
              modulo: self.supportModel.modulo ? self.supportModel.modulo : undefined,
              dataFineA: self.dataFineAValid ? self.supportModel.dataFineA : undefined,
              showAll: self.supportModel.vediPratiche ? self.supportModel.vediPratiche : undefined
            }
            break;
          case 'DOC':
            self.filter = {
              limit: 10,
              offset: 0,
              pageIndex: 1,
              totalPages: 0,
              orderColumnName: "UPDATE_DATE",
              orderType: "DESC",
              contractServicePojo: {
                idContract: self.supportModel.contratto && self.supportModel.contratto.numeroContratto ? self.supportModel.contratto.numeroContratto : null,
                modulo: self.supportModel.contratto && self.supportModel.contratto.numeroModulo ? self.supportModel.contratto.numeroModulo : null
              },
              docCategory: self.supportModel.docCategory ? self.supportModel.docCategory.value : undefined,
              docType: self.supportModel.docType ? self.supportModel.docType.value : undefined,
              refYear: self.supportModel.annoRiferimento ? self.supportModel.annoRiferimento : undefined,
              emissionDateFrom: self.emDtStartValid ? self.supportModel.emissionDateFrom : undefined,
              emissionDateTo: self.emDtEndValid ? self.supportModel.emissionDateTo : undefined,
              endDateFrom: self.dueDtStartValid ? self.supportModel.endDateFrom : undefined,
              endDateTo: self.dueDtEndValid ? self.supportModel.endDateTo : undefined,
              showAll: self.supportModel.vediPratiche ? self.supportModel.vediPratiche : undefined,
              numeroContratto: self.supportModel.contratto ? self.supportModel.contratto.numeroContratto : undefined,
              modulo: self.supportModel.contratto ? self.supportModel.contratto.numeroModulo : undefined,
              daLeggere: self.supportModel.daLeggere

            }
            break;
          default:
            self.filter = {
              limit: 10,
              offset: 0,
              pageIndex: 1,
              totalPages: 0,
              orderColumnName: "UPDATE_DATE",
              orderType: "DESC",
              status: self.stateSelected,
              ragSoc: self.supportModel.ragSocCliente,
              numeroAnno: self.supportModel.anno,
              numeroPreventivo: self.supportModel.preventivo,
              numeroContratto: self.supportModel.contratto,
              idCustomer: self.supportModel.pIvaCliente,
              startDate: self.dataInizioValid ? self.supportModel.dataInizio : undefined,
              endDate: self.dataFineValid ? self.supportModel.dataFine : undefined,
              id: self.supportModel.id ? self.supportModel.id : undefined,
              ndgVendorUser: self.supportModel.ndgVendorUser,
              ndgVendorSelected: self.supportModel.ndgVendorSelected,
              ndgSegnalatore: self.supportModel.ndgSegnalatore,
              ndgCustomer: self.supportModel.ndgCliente,
              categoriaRichiesta: self.categoriaSelezionata,
              tipoRichiesta: self.tipoRichiestaSelezionata,
              showAll: self.supportModel.vediPratiche ? self.supportModel.vediPratiche : undefined,
              showMyArea: self.supportModel.vediPraticheMyArea,
              product: self.prodottoSelezionato ? self.prodottoSelezionato.value : undefined,
              faseGestionale: self.faseGestionaleSelezionato ? self.faseGestionaleSelezionato.value : undefined,
              cdRaggrConvenzione: self.cdRaggrConvenzioneSelezionato ? self.cdRaggrConvenzioneSelezionato.value : undefined,
              ndgClientManager: self.clientManagerSelezionato ? self.clientManagerSelezionato.ndg : undefined,
              abi: self.abiSelezionato ? self.abiSelezionato.value : undefined,
              cab: self.cabSelezionato ? self.cabSelezionato.name : undefined,
              iter: self.statoIterDeliberaSelezionato ? self.statoIterDeliberaSelezionato.value : undefined,
              polo: self.poloRiferimentoSelezionato ? self.poloRiferimentoSelezionato.value : undefined
            }
            break;
        }

        self.onPressSearch({
          filter: self.filter
        })
      }

      self.handleChanges = function (comp, value) {
        switch (comp) {
          case 'docCat':
            self.supportModel.docType = null;
            if (value && value.moreLevels === true) {
              self.secondInput.previousSelections[0].value = value.value;
              $uniService
                .getDropDown(self.secondInput)
                .then(function (response) {
                  self.docTypes = response;
                })
            }

            if (value && value.value == 'comunicGarante') {
              $arcService.getContractsLight()
                .then(function (response) {
                  if (response.success) {
                    self.supportModel.contractList = response.listContratti
                  }

                })
            }

            if (value && value.value === 'fiscale') {
              self.supportModel.docType = null;
              self.enableDateFilters = true;
              self.supportModel.contract = undefined;
              if (!self.supportModel.emissionDateFrom || !self.supportModel.emissionDateTo) {
                var date = new Date();
                self.supportModel.emissionDateTo = moment(date).format('DD/MM/YYYY');
                self.supportModel.emissionDateFrom = moment(date, 'DD/MM/YYYY').subtract(6, 'months').format('DD/MM/YYYY');
              }
            } else {
              self.supportModel.docType = null;
              self.enableDateFilters = false;
              self.supportModel.emissionDateFrom = undefined;
              self.supportModel.emissionDateTo = undefined;
              self.supportModel.endDateFrom = undefined;
              self.supportModel.endDateTo = undefined;
              self.supportModel.contract = undefined;
            }
            break;
          case 'annoRif':
            break;
          default:
            return;
        }
        self.handleChange();
      }

      self.handleChangeCategory = function (value) {
        self.categoriaSelezionata = value;
        self.tipoRichiestaSelezionata = undefined;
      }

      self.getDropDownSubmittedRequestsPv = function () {
        self.lodearListaCategorie = true;
        $arcService.getDropDownSubmittedRequestsPv(self.categoriaSelezionata)
          .then(function (response) {
            if (!self.categoriaSelezionata) {
              self.listaCategorie = response.value;
            } else {
              self.listaTipoRichiesta = response.value;
            }
            self.lodearListaCategorie = false;
          })
      }

      self.getAllProducts = function () {
        self.loaderListaProdotti = true;
        $searchUserService.getAllProducts()
          .then(function (response) {
            self.listaProdotti = response.domainList;
            self.loaderListaProdotti = false;
          })
      }

      self.getAllFaseGestionale = function () {
        self.loaderListFaseGestionale = true;
        $typeDomainService
          .getDomainSet("PRACTICE", "FASE_GESTIONALE_CTR")
          .then(function (response) {
            self.listaFaseGestionale = response.domainList;
            self.loaderListFaseGestionale = false;
          })
      }

      self.getAllRaggrConvenzione = function () {
        self.loaderRaggrConvenzioni = true;
        $typeDomainService
          .getDomainSet("PRACTICE", "CD_RAGGR_CNV")
          .then(function (response) {
            self.listaCdRaggrConvenzione = response.domainList;
            self.loaderRaggrConvenzioni = false;
          })
      }

      self.getAllClientManager = function () {
        self.loaderListClientManager = true;
        $financialApiService.getAllClientManager()
          .then(function (response) {
            self.listaClientManager = response;
            self.loaderListClientManager = false;
          })
      }

      self.getAllAbi = function () {
        self.loaderListAbi = true;
        $financialApiService.getAllAbi()
          .then(function (response) {
            self.listaAbi = response;
            self.loaderListAbi = false;
          })
      }

      self.getAllCab = function (abi) {
        $financialApiService.getAllCab(abi, "")
          .then(function (response) {
            self.listaCab = response;
          })
      }

      self.getAllStatoIterDelibera = function () {
        $typeDomainService
          .getDomainSet("PRACTICE", "ITER_AUTH")
          .then(function (response) {
            self.listaStatoIterDelibera = response.domainList;
            self.statoIterDeliberaSelezionato = response.domainList[0];
          })
      }

      self.getAllElencoPoli = function () {
        self.loaderListaPoloRiferimento = true;
        $financialApiService.getElencoPoli()
          .then(function (response) {
            self.listaPoloRiferimento = response.domainList;
            self.loaderListaPoloRiferimento = false;
          })
      }
      self.getEndDate = function () {
        var endDate = moment("31/12", "DD/MM/YYYY")
          .add(-1, "years")
          .format("DD/MM/YYYY");
        return endDate
      }

      self.exportExcel = function () {
        self.showLoaderExport = true;
        self.filterExportExcel = {
          limit: 10,
          offset: 0,
          pageIndex: 1,
          totalPages: 0,
          orderColumnName: "UPDATE_DATE",
          orderType: "DESC",
          status: self.stateSelected ? self.stateSelected.value : null,
          ragSoc: self.supportModel.ragSocCliente,
          numeroAnno: self.supportModel.anno,
          numeroPreventivo: self.supportModel.preventivo,
          numeroContratto: self.supportModel.contratto,
          idCustomer: self.supportModel.pIvaCliente,
          startDate: self.dataInizioValid ? self.supportModel.dataInizio : undefined,
          endDate: self.dataFineValid ? self.supportModel.dataFine : undefined,
          id: self.supportModel.id ? self.supportModel.id : undefined,
          ndgVendorUser: self.supportModel.ndgVendorUser,
          ndgVendorSelected: self.supportModel.ndgVendorSelected,
          ndgSegnalatore: self.supportModel.ndgSegnalatore,
          ndgCustomer: self.supportModel.ndgCliente,
          categoriaRichiesta: self.categoriaSelezionata,
          tipoRichiesta: self.tipoRichiestaSelezionata,
          showAll: self.supportModel.vediPratiche ? self.supportModel.vediPratiche : undefined,
          showMyArea: self.supportModel.vediPraticheMyArea,
          product: self.prodottoSelezionato ? self.prodottoSelezionato.value : undefined,
          faseGestionale: self.faseGestionaleSelezionato ? self.faseGestionaleSelezionato.value : undefined,
          cdRaggrConvenzione: self.cdRaggrConvenzioneSelezionato ? self.cdRaggrConvenzioneSelezionato.value : undefined,
          ndgClientManager: self.clientManagerSelezionato ? self.clientManagerSelezionato.ndg : undefined,
          abi: self.abiSelezionato ? self.abiSelezionato.value : undefined,
          cab: self.cabSelezionato ? self.cabSelezionato.name : undefined,
          iter: self.statoIterDeliberaSelezionato ? self.statoIterDeliberaSelezionato.value : undefined,
          polo: self.poloRiferimentoSelezionato ? self.poloRiferimentoSelezionato.value : undefined
        }
        $simulationService.exportPractice(self.filterExportExcel)
          .then(function (response) {
            self.showLoaderExport = false;
          })
          .catch(function (error) {
            self.showLoaderExport = false;
          })
      }

      self.getAllStati = function () {
        if (self.statoPratiche.length) {
          return
        }
        statoPratiche();

      }

      self.getListOfAbi = function () {
        if (self.listaAbi.length) {
          return
        }
        self.getAllAbi();
      }

      self.getListClientemanger = function () {
        if (self.listaClientManager.length) {
          return
        }
        self.getAllClientManager();
      }

      self.getListacategorie = function () {
        if (self.listaCategorie.length && self.listaTipoRichiesta.length) {
          return;
        }

        self.getDropDownSubmittedRequestsPv();

      }

      self.getListaRaggrConvenzioni = function () {
        if (self.listaCdRaggrConvenzione.length) {
          return;
        }
        self.getAllRaggrConvenzione();
      }

      self.getListFaseGestionale = function () {
        if (self.listaFaseGestionale.length) {
          return;
        }
        self.getAllFaseGestionale();
      }

      self.getListaPoloRiferimento = function () {
        if (self.listaPoloRiferimento.length) {
          return
        }
        self.getAllElencoPoli();
      }


      self.getListaProdotti = function () {
        if (self.listaProdotti.length) {
          return;
        }
        self.getAllProducts();
      }

      self.populateContracts = function () {
        self.contractPending = true;
        $arcService.getContractsLight()
          .then(function (response) {
            if (response.success) {
              self.contractList = response.listContratti
              self.contractList.forEach(function (contract) {
                contract.numContrattoModulo = contract.numeroContratto + '/' + contract.numeroModulo + ' '
              })
            }
            self.contractPending = false;
          })
          .catch(function (err) {
            self.contractPending = false;
            console.log(err)
          })
      }

    }
  })